import React from 'react';
import { Box } from '@mui/material';
import { makeStyles } from '@material-ui/core/styles';
import { colors } from '../../theme/color-palette';
import Typography from '@mui/material/Typography';
import { Skeleton } from '@walmart-web/livingdesign-components';

const ShimmerTabs = () => {
	const useStyles = makeStyles(() => ({
		container: {
			borderBottom: `1px solid ${colors.LIST_BORDER_CLR}`,
		},
		header: {
			display: 'flex',
			marginTop: '30px',
			marginLeft: '22px',
		},
		tabs: {
			marginBottom: '15px !important',
		},
		tab: {
			marginLeft: '25px !important',
			marginBottom: '15px !important',
		},
	}));

	const classes = useStyles();
	return (
		<Box className={classes.container}>
			<Box className={classes.header}>
				<Typography className={classes.tabs}>
					<Skeleton height="12.25px" width="59px" variant="rounded" />
				</Typography>
				<Typography className={classes.tab}>
					<Skeleton height="12.25px" width="59px" variant="rounded" />
				</Typography>
				<Typography className={classes.tab}>
					<Skeleton height="12.25px" width="59px" variant="rounded" />
				</Typography>
			</Box>
		</Box>
	);
};

export default ShimmerTabs;
